import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { Loader } from 'components/util'
import ForgotPasswordForm from './ForgotPasswordForm'
import styles from './_forgotPassword.css'
import * as authActions from 'services/auth/actions'

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  ...authActions,
}

export class LoginPage extends Component {

  static propTypes = {
    onClickLogin: PropTypes.func,
    requestPasswordReset: PropTypes.func,
    redirectURI: PropTypes.string,
  }

  state = {
    submitting: false,
  }

  handleClickLogin = (evt) => {
    const { onClickLogin } = this.props
    evt.preventDefault()
    if (onClickLogin) { onClickLogin(evt) }
  }

  handleSubmit = ({ email }) => {
    this.setState({ submitting: true, email: email })
    this.props.requestPasswordReset(email, this.props.redirectURI)
      .then(() => {
        this.setState({ submitting: false, sent: true })
      })
      .catch(() => {
        this.setState({ submitting: false, sent: false, error: true })
      })
  }

  render () {
    const { submitting, sent, email } = this.state
    const { onClickLogin } = this.props

    return (
      <div className={styles.container}>
        <h1 className={styles.title}>
          <FormattedMessage
            id='auth.forgot_password.forgot_your_password'
            defaultMessage='Forgot your password?'
          />
        </h1>

        <ReactCSSTransitionGroup
          component='div'
          transitionName='fade'
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {submitting ?
            <div key='loader'>
              <div className={styles.loader}>
                <Loader height={50} width={50} />
              </div>
            </div>
          : null}
        </ReactCSSTransitionGroup>

        {!sent ?
          <div>
            <p className={styles.description}>
              <FormattedMessage
                id='auth.forgot_password.description'
                defaultMessage='No problem. Enter your email address and we’ll send you a link to reset it.'
              />
            </p>

            <ForgotPasswordForm
              sending={submitting}
              onSubmit={this.handleSubmit}
            />
          </div>
        : null}

        {sent ?
          <div className={styles.sentNote}>
            <p>
              <FormattedHTMLMessage
                id='auth.forgot_password.link_sent'
                defaultMessage='An email with a link to reset your Under Armour account password has been sent to <b>{email}</b>.'
                values={{ email }}
              />
            </p>

            <p>
              <FormattedMessage
                id='auth.forgot_password.if_dont_receieve'
                defaultMessage='If you do not receive an email from us in the next few minutes, please make sure you entered your address correctly and check your junk mail folder.'
              />
            </p>
            <p>
              <FormattedHTMLMessage
                id='auth.forgot_password.further_assistance'
                defaultMessage='If you need further assistance, please <a href="{url}">contact our support team</a>.'
                values={{ url: 'http://support.mapmyfitness.com/?_ga=1.251220230.1695163392.1484927502' }}
              />
            </p>
          </div>
        : null}

        {onClickLogin ?
          <Link className={classnames(styles.backToLogin, { [styles.sent]: sent })}
            to='/auth/login' onClick={this.handleClickLogin}>
            <FormattedMessage id='auth.forgot_password.back_to_log_in' defaultMessage='Back to Log In' />
          </Link>
        : null}

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(LoginPage)
